// src/components/channels/AddChannelModal.tsx
import { useTranslation } from 'react-i18next';
import Modal from '../ui/Modal'; // Adjust path if needed
import { Button } from '../ui/Button'; // Adjust path if needed
import { Loader2 } from 'lucide-react';

interface AddChannelModalProps {
  isOpen: boolean;
  onClose: () => void;
  base64QrString: string | null;
  isLoadingQr: boolean;
  errorQr?: string | null;
  onRetryFetchQr?: () => void;
}

export default function AddChannelModal({ 
  isOpen, onClose, base64QrString, isLoadingQr, errorQr, onRetryFetchQr 
}: AddChannelModalProps) {
  const { t } = useTranslation();
  return (
    <Modal isOpen={isOpen} onClose={onClose} title={t('scanQrCodeWithMobile')} size="sm">
      <div id="qr-code-container" className="mt-4 flex min-h-[280px] flex-col items-center justify-center rounded-md border border-gray-200 bg-gray-50 p-4">
        {isLoadingQr && (
          <div className="flex flex-col items-center text-center">
            <Loader2 className="h-12 w-12 animate-spin text-indigo-600" />
            <p className="mt-3 text-sm text-gray-600">{t('generatingQrCode')}</p>
          </div>
        )}
        {!isLoadingQr && base64QrString && (
          <img 
            id="qr-code-image"
            src={base64QrString} 
            alt="QR Code for adding channel" 
            className="h-auto w-full max-w-[250px] rounded-md" // Removed border, parent has it
          />
        )}
        {!isLoadingQr && !base64QrString && !errorQr && ( // Initial state before QR fetch attempt
          <p className="text-sm text-gray-500">{t('qrCodeWillAppear')}</p>
        )}
        {!isLoadingQr && errorQr && (
          <div className="text-center text-red-600">
            <p className="font-medium">{t('errorFetchingQrCode')}</p>
            <p className="text-sm">{errorQr}</p>
            {onRetryFetchQr && (
              <Button onClick={onRetryFetchQr} variant="outline" size="sm" className="mt-4 border-red-300 text-red-700 hover:bg-red-50">
                {t('tryAgain')}
              </Button>
            )}
          </div>
        )}
      </div>
      <p id="qr-instructions" className="mt-4 text-center text-xs text-gray-500">
        {t('scanWithPhone')}
      </p>
      <div className="mt-6 flex justify-end space-x-2">
        <Button variant="outline" onClick={onClose} className="border-gray-300 text-gray-700 hover:bg-gray-100">
          {t('close')}
        </Button>
      </div>
    </Modal>
  );
}
